module.exports = __webpack_public_path__ + "img/982.25519b36.gif";